import styled from "styled-components";

export const Logo = styled.div`
  width: calc(100%);
  height: 50px;
  display: flex;
  justify-content: flex-center;
  padding: 0;
`;

export const Header = styled.div`
  width: 100%;
  height: 48px;
  /* border-bottom: 1px solid #dddddd; */
  /* background: #ffffff; */
  font-size: 18px;
  font-weight: bold;
  display: flex;
  align-items: center;
  padding-left: 20px;
  justify-content: center;
`;
